

























































































































































































































































































































































import { Component, Prop, Emit, Vue } from 'vue-property-decorator';
import { ValidationProvider } from 'vee-validate';
import {
  film_type,
  production_country,
  language,
  type,
  rating,
  subtitle_language,
} from '@/components/const/SelectMovieOptions';
import InputGenreField from '@/components/InputGenreField.vue';
import FlLabeledInput from '@/components/FlLabeledInput.vue';
import FlSelect from '@/components/FlSelect.vue';
import InputTagsField from '@/components/InputTagsField.vue';
import FlSelectLanugages from '@/components/FlSelectLanugages.vue';
import ValidateParts from '@/components/ValidateParts.vue';
import { Movie } from '@/store/types';
import { UserMixin } from '@/Mixin';
import FlUrlInput from '@/components/FlUrlInput.vue';
import FlInput from '@/components/FlInput.vue';
import FlTranslatableTextarea from '@/components/FlTranslatableTextarea.vue';

@Component({
  components: {
    ValidationProvider,
    InputGenreField,
    FlLabeledInput,
    FlSelect,
    InputTagsField,
    FlSelectLanugages,
    ValidateParts,
    FlUrlInput,
    FlInput,
    FlTranslatableTextarea,
  },
  mixins: [UserMixin],
})
export default class Detail extends Vue {
  @Prop() public value!: Movie;
  @Emit() public input(value: object) {}
  autocompleteItems: object[] = [];
  inputGenres: object[] = [];
  imageErrors: object = {
    featured_image: '',
  };
  get mainGenres() {
    let genres = [];
    this.value.genres.forEach((item: any) => {
      if (item.is_main) {
        genres.push(item);
      }
    });
    return genres;
  }
  get subGenres() {
    let genres = [];
    this.value.genres.forEach((item: any) => {
      if (!item.is_main) {
        genres.push(item);
      }
    });
    return genres;
  }
  get isRequired() {
    return !(this as any).isImpersonated;
  }
  private get localValue(): object {
    return this.value;
  }

  private set localValue(value: object) {
    this.input(value);
  }
  get filmType() {
    return film_type;
  }
  get productionCountry() {
    return production_country;
  }
  get language() {
    return language;
  }
  get genreType() {
    return type;
  }
  get rating() {
    return rating;
  }
  get subtitleLanguage() {
    return subtitle_language;
  }
}
